import { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography,
} from "@mui/material";
import { QRCodeSVG } from "qrcode.react";
import { useScriptMode } from "../../../contexts/ScriptModeContext";

export default function ShareInviteModal({ open, groupId, templateId, groupName, onClose }) {
  const { t } = useScriptMode();
  const [copied, setCopied] = useState(false);
  const url = groupId && templateId ? `terakki://group/${groupId}/template/${templateId}` : "";

  const handleCopy = async () => {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (_) {
      // Clipboard API failure is silent — user can still copy manually
    }
  };

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontWeight: 600 }}>{t("manage_share_modal_title")}</DialogTitle>
      <DialogContent>
        {groupName ? (
          <Typography variant="subtitle2" sx={{ fontWeight: 600 }} mb={1}>
            {groupName}
          </Typography>
        ) : null}
        <TextField
          fullWidth
          label={t("manage_share_link_label")}
          value={url}
          InputProps={{ readOnly: true }}
          margin="normal"
        />
        <Button
          variant="outlined"
          onClick={handleCopy}
          sx={{ mb: 2 }}
        >
          {copied ? t("manage_share_copied") : t("manage_share_copy")}
        </Button>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Typography variant="caption" color="text.secondary">
            {t("manage_share_qr_label")}
          </Typography>
          {url ? <QRCodeSVG value={url} size={200} /> : null}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("manage_share_close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
